import * as React from 'react'
import { Accordion, Button, Card, Form } from 'react-bootstrap'

import {  AxiosInstance } from '../../../utils/RequestMethods'
import config from '../../../constants/config'
import { copyObject } from '../../../utils'

import { CompanyT } from '../../../types/Company'
import { ManualObj, ManualT } from '../../../types/Manual'


interface ManualProps {
    company : CompanyT
}

const Manual : React.FunctionComponent<ManualProps> = ({company}) : JSX.Element => {
    console.log('Company', company)
    let [manual, setManual] = React.useState(copyObject(ManualObj))

    React.useEffect((): void => {
        AxiosInstance.get(`${config.url.manuals}/${company.id}`).then((res) => {
            if (res && res.data) {
                console.log('AR: ', res.data)
                setManual(res.data)
                //setCompany(res.data)
            }
            //setIsReady(true)
        }).catch((error) => {
            console.log('FALSE: ', error)
            //setIsReady(true)
        })
    }, [])

    const updateManual = () => {
        AxiosInstance.post(`${config.url.manuals}/${company.id}`, {...manual}).then((res) => {
            console.log('UPDATE MANUAL: ', res)
        })
    }

    return (
        <div>
            <h3>Manual</h3>
            <Form>
                <Form.Group>
                    <Form.Label>Blurb</Form.Label>
                    <Form.Control
                        as="textarea"
                        className="input-material"
                        onChange={(e : any) => {
                            let newManual = copyObject(manual)
                            newManual.blurb = e.target.value
                            setManual(newManual)
                        }}
                        rows={3}
                        value={manual.blurb} />
                </Form.Group>
                <Button
                    onClick={() => {
                        updateManual()
                    }}>Save</Button>
            </Form>
        </div>
    )
}

export default Manual
